/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import {
  listCalendars,
  getCalendar,
  createCalendar,
  updateCalendar,
  connectGoogle,
  syncGoogle,
  disconnectGoogle,
  getGoogleSettings,
  updateGoogleSettings,
  deleteCalendar,
} from './CalendarService.calendars';
import {
  listEvents,
  getEvent,
  createEvent,
  updateEvent,
  deleteEvent,
} from './CalendarService.events';

/**
 * CalendarService — calendars and events under an agency.
 *
 * The backend does not expand recurrences; callers expand RRULE client-side.
 */
export class CalendarService {
  public static listCalendars = listCalendars;
  public static getCalendar = getCalendar;
  public static createCalendar = createCalendar;
  public static updateCalendar = updateCalendar;
  public static connectGoogle = connectGoogle;
  public static syncGoogle = syncGoogle;
  public static disconnectGoogle = disconnectGoogle;
  public static getGoogleSettings = getGoogleSettings;
  public static updateGoogleSettings = updateGoogleSettings;
  public static deleteCalendar = deleteCalendar;

  public static listEvents = listEvents;
  public static getEvent = getEvent;
  public static createEvent = createEvent;
  public static updateEvent = updateEvent;
  public static deleteEvent = deleteEvent;
}
